import { Component, OnInit } from '@angular/core';
import { ViewService } from '@services/view.service';
import { RemoveService } from '@services/remove.service';
import { GlobalService } from '@common/global';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
import { AddService } from '@services/add.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-cartlist',
  templateUrl: './cartlist.component.html',
  styleUrls: ['./cartlist.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class CartlistComponent implements OnInit {
  page_loading = true;
  component = 'e';
  application = "cart";
  response: any = [];
  currency = "";
  items: any = [];
  constructor(private _addService: AddService, private _remove: RemoveService, private _viewService: ViewService, private _global: GlobalService) {
    this.currency = this._global.getCurrency().toLowerCase();
    this.cartList();
  }

  ngOnInit(): void {
  }
  cartList() {
    this.page_loading = true;
    this.items = [];
    let p = {
      'component': this.component,
      'application': this.application
    };
    this._viewService.cart(p).subscribe(
      data => {
        this.page_loading = false;
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.response = this._global.getVal(data, 'response', '');
          this.items.push(this._global.getVal(this.response, 'cart.items', []));
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  remove(pid) {

    let p = {
      "component": this.component,
      "application": 'cart',
      productId: pid
    };
    this._remove.application(p).subscribe(
      data => {
        let message = '';
        if (data["status"] == "1") {
          message = this._global.getVal(data, 'message.info', "");
          this._global.showMessage({ "type": 'success', "message": message });
          this.cartList();
        } else {
          this._global.showMessage({ "type": 'warning', "message": this._global.getVal(data, 'message.error', '') });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  increaseQuantity(qty: number, pid) {
    if (qty >= 1) {
      qty = qty + 1;
      this.addtoCart(qty, pid);
    }
  }
  decreaseQuantity(qty: number, pid) {
    if (qty > 1) {
      qty = qty - 1;
      this.addtoCart(qty, pid);
    }
  }

  addtoCart(qty, id) {
   
    let p = {
      component: this.component,
      application: 'cart',
      quantity: qty,
      productId: id,
      previousQuantity: 1
    };
    this._addService.application(p).subscribe(
      data => {
        let message = '';
        if (data["status"] == "1") {
          message = this._global.getVal(data, 'message.info', "");
          this._global.showMessage({ "type": 'success', "message": message });
          this.cartList();
        } else {
          this._global.showMessage({ "type": 'warning', "message": this._global.getVal(data, 'message.error', '') });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }


}
